import { DISTRIBUTION_SYSTEM_COPY } from '#app/routes/mocra+/_form+/components/distribution-systems/constants.ts'
import { RECALL_DISTRIBUTION_SYSTEM_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

export type DistributionSystemValue =
	(typeof RECALL_DISTRIBUTION_SYSTEM_OPTIONS)[number]['value']

export type DistributionSystemDraft = {
	system: DistributionSystemValue
	dataset: string
}

export function createDistributionSystemDraft(
	overrides: Partial<DistributionSystemDraft> = {},
): DistributionSystemDraft {
	return {
		system: RECALL_DISTRIBUTION_SYSTEM_OPTIONS[0]?.value ?? 'erp',
		dataset: '',
		...overrides,
	}
}

export function sanitizeDistributionSystemDraft(
	draft: DistributionSystemDraft,
): DistributionSystemDraft {
	const system = isDistributionSystemValue(draft.system)
		? draft.system
		: (RECALL_DISTRIBUTION_SYSTEM_OPTIONS[0]?.value ?? 'erp')
	return {
		system,
		dataset: draft.dataset.trim(),
	}
}

export function collectDistributionSystemErrors(
	draft: DistributionSystemDraft,
): string[] {
	const sanitized = sanitizeDistributionSystemDraft(draft)
	const errors: string[] = []
	if (sanitized.dataset.length === 0) {
		errors.push('Describe the dataset or report.')
	}
	return errors
}

export function distributionSystemCardTitle(
	draft: DistributionSystemDraft,
): string {
	const sanitized = sanitizeDistributionSystemDraft(draft)
	const label = resolveDistributionSystemLabel(sanitized.system)
	return label
}

export function formatDistributionSystemSummary(
	draft: DistributionSystemDraft,
): string {
	const sanitized = sanitizeDistributionSystemDraft(draft)
	return sanitized.dataset || DISTRIBUTION_SYSTEM_COPY.summary.datasetMissing
}

export function resolveDistributionSystemLabel(
	value: DistributionSystemValue,
): string {
	return (
		RECALL_DISTRIBUTION_SYSTEM_OPTIONS.find((option) => option.value === value)
			?.label ?? value
	)
}

export function isDistributionSystemValue(
	value: unknown,
): value is DistributionSystemValue {
	return RECALL_DISTRIBUTION_SYSTEM_OPTIONS.some(
		(option) => option.value === value,
	)
}
